import UnitTestCollectionView from 'scripts/defa/unit-tests/view-unit-test-collection-view';
import View                   from 'scripts/poppet/view';
import template               from 'templates/unitInfo.jst.html';

const UnitInfo = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template       : template,
	
	
	modelEvents: {
		'change': 'render',
	},

	
	templateContext: function () {
		let templateContext = {
			alias               : this.model.get('alias'),
			serial              : this.model.get( 'serialNumber' ) || '&nbsp;',
			showSerialNumber    : true,
			showTestResult      : true,
			unitType            : this.model.getUnitType(),
			subscriptionName    : this.model.subscriptionName(),
			customerName        : this.model.customerName(),
			vehicleName         : this.model.vehicleName(),
			alarmCentralName    : this.model.alarmCentralName(),
			insuranceCompanyName: this.model.insuranceCompanyName(),
			showTechnical       : this.showTechnical(),
			iconClass			: this.getIconClass(),
		};
		if(this.showTechnical()){
			let tech = this.options.tech;
			templateContext.iccid = tech.get('iccid');
			templateContext.ipAddress = tech.get('ipAddress');
			templateContext.activeSim = tech.get('activeSim');
			templateContext.isChipSim = tech.get('isChipSim');
		}
		return templateContext;
	},
	
	showTechnical: function () {
		return this.options.tech && this.options.tech != null;
	},
	
	getIconClass: function() {
		return 'icon-' + (this.model.get( 'family' ).toLowerCase());
	}
	
	
} );




export default UnitInfo;